import Icon from '../components/Icon.vue'

Icon.register({
  'hourglass-start': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M360 0c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24 0 91-51 167.7-120.8 192 69.8 24.3 120.8 101 120.8 192 13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24 0-91 51-167.7 120.8-192-69.8-24.3-120.8-101-120.8-192-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h336zM296 448c0-77.5-46.2-144-104-144-57.8 0-104 66.5-104 144h208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hourglass-start.js
// module id = 1473
// module chunks = 0